"use client";

import dynamic from "next/dynamic";

// ssr:false requires a client boundary — this thin wrapper lets the server
// homepage keep the widget browser-only (it reads localStorage on mount).
const DailyChallengeWidget = dynamic(() => import("./DailyChallengeWidget"), { ssr: false });

export default function DailyChallengeWidgetLazy({ isCompact = false }: { isCompact?: boolean }) {
  return <DailyChallengeWidget isCompact={isCompact} />;
}
